import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface WorkLocation {
  _id: string;
  name: string;
  clientId: string;
}

interface UserWorkLocations {
  [userId: string]: WorkLocation[];
}

interface ClientLocations {
  [clientId: string]: WorkLocation[];
}

interface WorkLocationsState {
  userLocations: UserWorkLocations;
  clientLocations: ClientLocations;
}

const initialState: WorkLocationsState = {
  userLocations: {},
  clientLocations: {},
};

export const workLocationsSlice = createSlice({
  name: "workLocationsSlice",
  initialState,
  reducers: {
    setUserWorkLocations(
      state: WorkLocationsState,
      action: PayloadAction<{ userId: string; locations: WorkLocation[] }>,
    ) {
      state.userLocations[action.payload.userId] = action.payload.locations;
    },
    clearUserWorkLocations(
      state: WorkLocationsState,
      action: PayloadAction<string>,
    ) {
      delete state.userLocations[action.payload];
    },
    setClientLocations(
      state: WorkLocationsState,
      action: PayloadAction<{ clientId: string; locations: WorkLocation[] }>,
    ) {
      state.clientLocations[action.payload.clientId] = action.payload.locations;
    },
    clearClientLocations(
      state: WorkLocationsState,
      action: PayloadAction<string>,
    ) {
      delete state.clientLocations[action.payload];
    },
    clearAllWorkLocations() {
      return {
        userLocations: {},
        clientLocations: {},
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setUserWorkLocations,
  clearUserWorkLocations,
  setClientLocations,
  clearClientLocations,
  clearAllWorkLocations,
} = workLocationsSlice.actions;

export default workLocationsSlice.reducer;
